<template>
  <div class="h-screen pb-safe flex flex-col overflow-hidden">
    <top-bar-desktop :show-back="showBack" v-if="!isMobile">
      <template #left>
        <div v-if="showBack" class="pr-3 text-v-400" @click="$emit('back')">
          <div class="p-3 -m-3">
            <l-icon size="medium" name="bracket-left" />
          </div>
        </div>
        <span v-else><!-- Added to prevent to show default slot content--></span>
      </template>
      <template #center>
        <span class="heading-3">
          {{ title }}
        </span>
      </template>
      <template #right>
        <l-button
          v-if="showClose"
          size="medium"
          icon="close"
          type="text"
          color="white"
          @click="$emit('close')"
        />
        <span v-else><!-- Added to prevent to show default slot content--></span>
      </template>
    </top-bar-desktop>
    <top-bar-mobile
      v-else
      :show-close="showClose"
      :show-back="showBack"
      @close="$emit('close')"
      @back="$emit('back')"
    >
      <template #[mobileSlot]>
        <span class="heading-3">
          {{ title }}
        </span>
      </template>
    </top-bar-mobile>
    <div class="overflow-y-scroll scrolling-touch w-full h-full bg-n-800 relative">
      <slot />
    </div>
    <div v-if="$slots.footer" class="p-4 pb-7 flex justify-center">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { computed } from 'vue'

import { LButton, LIcon } from '@last/core-ui/paprika'

import TopBarDesktop from './TopBar.vue'
import TopBarMobile from './TopBarMobile.vue'

const props = withDefaults(
  defineProps<{
    title: string
    showBack?: boolean
    showClose?: boolean
  }>(),
  {
    showBack: false,
    showClose: true
  }
)

defineEmits<{
  close: []
  back: []
}>()

const mobileSlot = computed(() => (props.showBack ? 'center' : 'left'))

const isMobile = useBreakpoints(breakpointsTailwind).smallerOrEqual('sm')
</script>
